<script lang="ts">
	import type { OperationModel } from '@app/models/api/OperationModel';

	export let slug: string = null;
	export let operation: OperationModel;
</script>
